import { Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CollectiveDataProvider } from '../_providers/collective-data-provider';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../_providers/collective-data-provider";
export class PublicRedirectionGuard {
    constructor(router, collectiveDataProvider) {
        this.router = router;
        this.collectiveDataProvider = collectiveDataProvider;
        this.collectiveConfig = null;
    }
    canActivate(next, state) {
        return combineLatest(this.collectiveDataProvider.getData(), this.collectiveDataProvider.getLoadState()).pipe(filter((result) => result[1] !== 'loading'), take(1), map((result) => {
            this.collectiveConfig = result[0];
            const loadState = result[1];
            if (loadState === 'error' || environment.protected || this.collectiveConfig.active === 0) {
                return true;
            }
            if (this.collectiveConfig.active === 1) {
                return this.router.parseUrl(`/${next.params.locale}/service-index`);
            }
            return true;
        }));
    }
}
PublicRedirectionGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PublicRedirectionGuard_Factory() { return new PublicRedirectionGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.CollectiveDataProvider)); }, token: PublicRedirectionGuard, providedIn: "root" });
